import { LicenseInfo } from '@mui/x-license';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { appRoutes } from './appRoutes';
import App from './common/App';
import './faro/FaroClient';
import { MUI_LICENSE_KEY } from './mui-license-key';

LicenseInfo.setLicenseKey(MUI_LICENSE_KEY);

const root = createRoot(document.getElementById('app'));

root.render(
    <App
        /**
         * @todo:
         * 1. Extract as a module constant, export and re-use here and elsewhere (AppRouter and AppRoute)
         * its needed, instead of prop drilling.
         * 2. Improve TS typing of the "route" shape.
         */
        routes={appRoutes}
    />
);
